module.exports = __webpack_public_path__ + "static/media/16.4e97bde2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/16.svg
// module id = 128
// module chunks = 0